import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  VegaImageUploader,
  VegaLoadingIndicator
} from "@heartlandone/vega-react";

const MultiImageUploader = ({onImageChangeCallback = () => {}, onImageRemoveCallback = () => {}, maxFiles = 0, imageUrls = [], isEdit = false}) => {
  const [_images, setImages] = useState({});
  const [handValue, setHandValue] = useState(null);
  const [operateId, setOperateId] = useState(-1);
  const [disabled, setDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isEdit && imageUrls?.length > 0) {
      setIsLoading(true)
      Promise.all(imageUrls.map(({id, url}) => {
        return fetch(url).then(res => res.blob())
      })).then(res => {
        const __images = {};
        imageUrls.forEach((image, index) => {
          __images[image.id] = res[index];
        });
        setImages(__images);
      }).finally(() => {
        setIsLoading(false);
      });
    } else if (!isEdit) {
      // setImages({});
    }

  }, [imageUrls, imageUrls?.length, isEdit]);

  const _onImageChange = async (e, id = '') => {
    const index = id ? id : Object.keys(_images).length;
    if(e.detail) {
      setIsLoading(true);
      setOperateId(index);
      onImageChangeCallback({
        file: e.detail,
        originalId: index,
      }, e).then((image) =>{
        setImages({..._images, ...image})
        setOperateId(-1);
      }).finally(() => {
        setIsLoading(false);
      })
    }
    setHandValue(null);
  }

  const onImageRemove = (id) => {
    setOperateId(id);
    onImageRemoveCallback(id).then((_id) => {
      const images = {..._images};
      delete images[id];
      setImages(images);
      setOperateId(-1);
    });
  }

  useEffect(() => {
    const keys = Object.keys(_images);
    if (maxFiles <= 0) {
      setDisabled(false);
      return
    }
    setDisabled(keys.length >= maxFiles);
    // eslint-disable-next-line
  }, [_images])

  return (
    <div>
      <div className="relative">
        {
          disabled && <div style={{ position: 'absolute', top: 16, width: 120, height: 120, opacity: 0.5, backgroundColor: 'white', zIndex: 9999 }}></div>
        }
        <VegaLoadingIndicator mode={`indeterminate`} style={{ display: isLoading ? 'block' : 'none', position: 'absolute', top: 50, left: 35, zIndex: 9999}}/>
        <VegaImageUploader
          height="120"
          style={{ float: 'left' }}
          className="m-r-16 m-t-16"
          value={handValue}
          onVegaChange={(e) => _onImageChange(e)}
        />
      </div>
      {
        Object.keys(_images).length > 0 && Object.keys(_images).map((id) => {
            return <div style={{ position: 'relative', float: 'left' }} key={id}>
                <VegaLoadingIndicator mode={`indeterminate`} style={{ display: operateId === id ? 'block' : 'none', position: 'absolute', top: 50, left: 35, zIndex: 9999}}/>
                <VegaImageUploader
                  key={id}
                  className="m-r-16 m-t-16"
                  height="120"
                  showReplaceButton={false}
                  value={_images[id]}
                  onVegaRemove={(e) => onImageRemove(id, e)}
                />
            </div>
          }
        )
      }
    </div>
  );
};

MultiImageUploader.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
  radius: PropTypes.string
};

export default MultiImageUploader;
